import React, { useState, useEffect } from 'react';
import { Form, Input, Checkbox, Select, Button, Modal, InputNumber } from 'antd';
import { CreateCategory, CreateSubCategory, equipWOCategory, equipWOSubCategory } from '../../../../Services/LocomotiveServices';
import { useRef } from 'react';

const { Option } = Select;

const AddWoForm = ({ onSubmit }) => {
    const formRef = useRef(null);

    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [showInput, setShowInput] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [otherValue, setOtherValue] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [isSubCategoryModalVisible, setIsSubCategoryModalVisible] = useState(false);
    const [newSubCategoryName, setNewSubCategoryName] = useState('');

    const handleButtonClick = () => {
        setIsModalVisible(true);
    };

    const handleModalOk = () => {
        setIsModalVisible(false);
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        fetchCategories();
    }, []);
    const fetchCategories = async () => {
        try {
            const categoriesData = await equipWOCategory();
             

            if (categoriesData && categoriesData.data && Array.isArray(categoriesData?.data)) {
                setCategories(categoriesData.data.map(item => ({ id: item.id, name: item.Category })));
            } else {
                console.error("Invalid categories data:", categoriesData);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchSubCategories = async (categoryId) => {

        try {
            const res = await equipWOSubCategory(categoryId);
            if (res?.httpStatus != 200) return
            setSubCategories(res?.data);
            setShowDropdown(true);
            setShowInput(false);
        } catch (error) {
            console.error('Error fetching subcategories:', error);
        }

    };


    const handleCategoryChange = async (value) => {
        setSelectedCategory(value);
        formRef.current.setFieldsValue({ SubCategoryId: undefined });

        await fetchSubCategories(value);
    };


    const handleDropdownChange = (value) => {
        setSelectedOption(value);
        setShowDropdown(value === 'Number');
        setShowInput(value === '');
    };
    const handleOtherValueChange = (e) => {
        setOtherValue(e.target.value);
    };
    const handleFormSubmit = async (values) => {
        if (values.PositionType === "") {
            delete values.Others;
            values.PositionType = otherValue || '';
        }
        onSubmit(values);

        try {
            await formRef.current.resetFields();
        } catch (error) {
            console.error('Error resetting form:', error);
        }
    };

    // Function for add category
    const handleCategorySubmit = async () => {
        try {
            const payload = {
                name: newCategoryName
            };
             
            await CreateCategory(payload);
            await fetchCategories();
            setIsModalVisible(false);
            setNewCategoryName('');
        } catch (error) {
            console.error('Error creating category:', error);
        }
    };

    // sub category added

    const handleSubCategoryButtonClick = () => {
        setIsSubCategoryModalVisible(true);
    };

    const handleSubCategoryModalCancel = () => {
        setIsSubCategoryModalVisible(false);
        setNewSubCategoryName('');
    };

    const handleSubCategoryModalOk = async () => {
        try {

            const payload2 = {
                WOCategoryId: selectedCategory,
                name: newSubCategoryName
            };
            await CreateSubCategory(payload2);

            await fetchSubCategories(selectedCategory);

            setIsSubCategoryModalVisible(false);

            setNewSubCategoryName('');
        } catch (error) {
            console.error('Error creating subcategory:', error);
        }
    };

    return (
        <Form
            ref={formRef}

            labelCol={{
                span: 5,
            }}
            wrapperCol={{
                span: 16,
            }}
            layout="horizontal"
            style={{
                maxWidth: 900,
            }}
            name="form"
            onFinish={handleFormSubmit}

        >
            <Form.Item name="category" label="Category"
                rules={[
                    {
                        required: true,
                        message: 'Please input text!',
                    },

                ]}>

                <Select onChange={handleCategoryChange}>
                    {categories.map(category => (
                        <Option key={category.id} value={category.id}>
                            {category.name}
                        </Option>
                    ))}
                    <Option disabled key="button" value="button">
                        <Button style={{ background: '#2963AD', color: 'white' }} onClick={handleButtonClick}>Add Category</Button>
                    </Option>
                </Select>


            </Form.Item>
            {selectedCategory && (
                <Form.Item name="SubCategoryId" label="Subcategory"
                    rules={[
                        {
                            required: true,
                            message: 'Please input text!',
                        },
                    ]}
                >
                    <Select>
                        {subCategories.map(subCategory => (
                            <Option key={subCategory.id} value={subCategory.id}>{subCategory.SubCategory}</Option>
                        ))}
                        <Option disabled key="button" value="button">
                            <Button style={{ background: '#2963AD', color: 'white' }} onClick={handleSubCategoryButtonClick}>Add subCategory</Button>
                        </Option>
                    </Select>
                </Form.Item>
            )}
            <Form.Item name="Task" label="Task"
                rules={[
                    {
                        required: true,
                        message: 'Please input text!',
                    },
                    {
                        max: 250,
                        message: 'Task must be at most 250 characters!',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item name="Part" valuePropName="checked" initialValue={false} wrapperCol={{ offset: 5, span: 14 }} >
                <Checkbox>Parts Required</Checkbox>
            </Form.Item>
            <Form.Item name="Notes" valuePropName="checked" initialValue={false} wrapperCol={{ offset: 5, span: 14 }} >
                <Checkbox >Notes Required</Checkbox>
            </Form.Item>

            <Form.Item name="PositionType" label="Position">
                <Select onChange={handleDropdownChange}>
                    <Option value="Number">Number</Option>
                    <Option value="">Others</Option>
                </Select>
            </Form.Item>
            {showDropdown && (
                <>
                    <Form.Item
                        name="PositionHigh"
                        label="High"
                        rules={[
                            {
                                required: true,
                                message: 'Please input Number!',
                            },
                        ]}
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="PositionLow"
                        label="Low"
                        rules={[
                            {
                                required: true,
                                message: 'Please input Number!',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('PositionHigh') >= value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('The value must be lower than the value entered in High.'));
                                },
                            }),
                        ]}
                    >
                        <InputNumber />
                    </Form.Item>
                </>


            )}
            {showInput && (
                <Form.Item name="Others" label="Other Value" rules={[
                    {
                        required: true,
                        message: 'Please input text!',
                    },

                ]}>
                    <Input onChange={handleOtherValueChange} />
                </Form.Item>
            )}
            <Form.Item wrapperCol={{ offset: 10, span: 14 }}>
                <Button style={{ background: '#2963AD', color: 'white' }} htmlType="submit">Submit</Button>
            </Form.Item>
            {/* category modal */}
            <Modal
                title="Add Category"
                visible={isModalVisible}
                onOk={handleCategorySubmit}
                onCancel={handleModalCancel}
            >
                <Input
                    name='Addcategory'
                    placeholder="Enter category name"
                    value={newCategoryName}
                    onChange={(e) => setNewCategoryName(e.target.value)}
                />
            </Modal>

            {/* Sub Category  modal */}
            <Modal
                title="Add Subcategory"
                visible={isSubCategoryModalVisible}
                onOk={handleSubCategoryModalOk}
                onCancel={handleSubCategoryModalCancel}
            >
                {/* Select to choose category */}
                <Form.Item name="category" label="Category"
                    rules={[
                        {
                            required: true,
                            message: 'Please select a category!',
                        },
                    ]}
                >
                    <Select onChange={(value) =>  {}}>
                        {categories.map(category => (
                            <Option key={category.id} value={category.id}>
                                {category.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                {/* Input field to enter subcategory name */}
                <Form.Item name="subCategory" label="SubCategory:"
                    rules={[
                        {
                            required: true,
                            message: 'Please input text!',
                        },
                    ]}
                >
                    <Input
                        placeholder="Enter subcategory name"
                        value={newSubCategoryName}
                        onChange={(e) => setNewSubCategoryName(e.target.value)}
                    />
                </Form.Item>
            </Modal>



        </Form>
    );
}

export default AddWoForm;
